import styled from 'styled-components';
import { align } from '@bucket-of-bolts/styled-companion/build';
import { cell, grid, maxWidth, media, paddingLg, withTheme } from '../../style';
import { effect, withEffects } from '../../lib/effects';
import Img from 'gatsby-image';

export const AboutBlockContainer = withTheme(styled.div`
    max-width: ${maxWidth};
    margin: 2rem 1rem;
    ${media({ xs: 'margin: 2rem 0rem;', lg: paddingLg })}
    ${align('center', 'center', 'column')};
    position: relative;

    // @ts-ignore
    font-size: ${(props) => props.theme.font[props.fontSize]};

    // @ts-ignore
    // ${(props) => effect(props)}
`);

export const AboutTitle = withTheme(styled.h1`
    ${media({ xs: 'font-size: 1.4rem' })}
`);
export const AboutInner = withTheme(styled.div`
    padding: 0;
    max-width: 100%;
    ${media({ xs: 'h1 { font-size: 1.4rem}' })}
    //${media({ xs: 'max-width: 80%', sm: 'max-width: 70%' })};
    // @ts-ignore
    font-size: ${(props) => props.theme.font[props.fontSize]};
    font-weight: 300;
    text-align: justify;
`);

export const Image = styled(Img)`
    margin-top: 1rem;
    width: 100%;
    height: auto;
    background-color: #f2f1ef;
    border-radius: 2px;
`;
